import { type FeatureModule } from '@store/features/types';
import localStorage from 'redux-persist/lib/storage';

import toolbarReducer from './slice';

export const toolbar: FeatureModule = {
  id: 'toolbar',
  name: 'Toolbar',

  dependencies: [],

  reducers: {
    toolbar: toolbarReducer,
  },

  middleware: [],

  // Enable persistence for badge counts and preferences
  persistence: {
    enabled: true,
    key: 'toolbar',
    storage: localStorage,
    whitelist: ['actions', 'preferences'],
    blacklist: ['isVisible', 'scrollControlEnabled', 'actionContext'],
    version: 1,
    mergeStrategy: 'merge',
  },

  // Enable sync for badge updates across tabs
  sync: {
    enabled: true,
    whitelist: [
      'toolbar/updateBadgeCount',
      'toolbar/incrementBadgeCount',
      'toolbar/decrementBadgeCount',
      'toolbar/clearBadgeCount',
    ],
  },

  setup: _store => {
    // Feature initialized
  },

  cleanup: _store => {
    // Feature cleaned up
  },
};
